import naja from 'naja';

export default {
	init() {
		naja.uiHandler.selector = '.najax';

		naja.initialize({
			//history: false
		});

		//Zpřístupní naju globálně
		//ToDo: Kontrola, kde všude se používá CTToast a přesměrování sem
		window.naja = naja;

		naja.addEventListener('error', this.handleErrorEvent);
		naja.addEventListener('complete', this.handleCompleteEvent);

		document.dispatchEvent(new CustomEvent('najaInitialized'));

	},
	handleErrorEvent(event) {
		if (event.detail.options.customErrorHandling === true) {
			return;
		}

		console.log('error - start');
		console.log(event.detail);
		console.log(event.detail.response.body);
		console.log('error - end');
		showCTtoast('Došlo k chybě', event.detail.error.message, 'danger');
	},

	handleCompleteEvent(event) {
		if (event.detail.payload) {
			const message = event.detail.payload.message;
			const messageType = event.detail.payload.messageType;
			const messageTitle = event.detail.payload.error ? 'Chyba' + (event.detail.payload.code ? ' #' + event.detail.payload.code : '') : '';

			if (message !== undefined) {
				showCTtoast(messageTitle, message, messageType ?? 'info');
			}
		}
	}
}
